import { html, LitElement } from "lit"
import { query } from 'lit/decorators';
import type { SiteMenu } from '../rps-site-menu/site-menu';
import { manageFloatingHeader } from "./RpsStickyElements"

export default class RpsHeader extends LitElement {

  @query('#mainMenuBtn')
  private mainMenuButton!: HTMLButtonElement;

  @query('rps-site-menu')
  private siteMenu!: SiteMenu;

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
  }

  render() {
    return html``;
  }

  firstUpdated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.firstUpdated(_changedProperties);
    this.mainMenuButton.addEventListener('click', () => {
      this.siteMenu.open();
    });

    manageFloatingHeader()
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rps-header': RpsHeader
  }
}
